import { ProjectDetailInfo } from "@/pages/contracten/contract_detail/ProjectDetailInfo"
import { createFileRoute, useParams } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/beheer/contracten/$contractId/gegevens/",
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { contractId } = useParams({
    from: "/beheer/contracten/$contractId/gegevens/",
  })

  return <ProjectDetailInfo projectId={Number(contractId)} />
}
